import React, { useEffect, useState } from "react";
import { UserRole } from "../../providers/authProvider";
import {
  FormDataConsumer,
  InputProps,
  ReferenceInput,
  required,
  SelectInput,
  useChoicesContext,
  useDataProvider,
  useGetIdentity,
  useNotify,
  UseReferenceInputControllerParams
} from "react-admin";
import { getCompanyId } from "../../utils/utils";

type VehicleOperationInputProps = InputProps &
  UseReferenceInputControllerParams & {
    label?: string;
    [key: string]: any;
  }

const VehicleOperationInput: React.FC<VehicleOperationInputProps> = ({ source, label, reference }) => {
  const { identity } = useGetIdentity();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [companyConfig, setCompanyConfig] = useState<{ [key: string]: string | boolean } | null>({});

  useEffect(() => {
    if (identity?.role === UserRole.company) {
      dataProvider
        .getOne(`company-config`, { id: getCompanyId() })
        .then(({ data }) => setCompanyConfig(data))
        .catch(() => {
          setCompanyConfig(null);
          notify('Erro ao buscar configurações atuais', { type: 'warning' });
        });
    } else if (identity?.role === UserRole.admin) {
      setCompanyConfig({});
    }
  }, [identity]);

  const OperationSelectInput = ({ optionText }: { optionText: string }) => {
    const context = useChoicesContext();
    return (
      <SelectInput
        label={label}
        emptyText="ra.action.clear_input_value"
        validate={companyConfig?.isFillinWithoutOperation ? undefined : required()}
        source={context.source}
        fullWidth
        choices={(context.allChoices || []).map(item => ({ id: item.id, [optionText]: `${('0000' + item.code).slice(-4)} - ${item.name}` }))}
      />
    );
  }



  return (
    <FormDataConsumer>
      {({ formData }) => {
        return (
          <ReferenceInput
            source={source}
            reference={reference}
            sort={{ field: 'code', order: 'ASC' }}
            pagination={null}
            perPage={null}
            filter={
              {
                isInactive: false,
                ...(identity?.role === UserRole.company ? { companyId: getCompanyId() }
                  : formData.companyId ? { companyId: formData.companyId } : null)
              }
            }
          >
            <OperationSelectInput optionText="name" />
          </ReferenceInput>
        )
      }}
    </FormDataConsumer>
  );
}

export default VehicleOperationInput;